<template>
  <form
    autocomplete="off"
    class="gap-0 gap-y-4"
    @submit.prevent="submitForm"
  >
    <div class="col-span-12 mx-auto text-center w-full">
      <h2>
        Change Category
      </h2>

      <AppDropdown
        class="admin-dropdown text-gray-dark my-auto"
        :trigger-text="categoryText || 'Selected category'"
      >
        <AppDropdownItem
          @click="selectedCategory = null; categoryText = 'No Category'"
        >
          No Category
        </AppDropdownItem>

        <template
          v-for="category in categories"
          :key="category.id"
        >
          <AppDropdownItem
            @click="selectedCategory = category.id; categoryText = category.name"
          >
            {{ category.name }}
          </AppDropdownItem>
        </template>
      </AppDropdown>

      <div class="flex gap-3 mt-6">
        <AppButton
          :disabled="isSubmitting"
          class="btn btn-outline btn-secondary py-2.5 w-full"
          @click="$emit('close')"
        >
          Cancel
        </AppButton>

        <AppButton
          :processing="isSubmitting"
          class="btn btn-solid btn-secondary py-2.5 w-full"
        >
          {{ isSubmitting ? 'Confirming' : 'Confirm' }}
        </AppButton>
      </div>
    </div>
  </form>
</template>

<script setup>
import { ref } from 'vue';

import { AppButton, AppDropdown, AppDropdownItem } from '@/components/app';

const emit = defineEmits(['close', 'confirm']);

const props = defineProps({
  categories: {
    type: Array,
    default: () => [],
  },
  isSubmitting: Boolean,
});

const categoryText = ref(null);
const selectedCategory = ref(null);

const submitForm = () => {
  if (!props.isSubmitting) {
    emit('confirm', selectedCategory.value);
  }
};

</script>
